// var mapStyle = [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]
var AppConstants = {}

AppConstants.install = function (Vue, options) {
  Vue.prototype.appConstants = {
    // mapStyle: mapStyle,
    facebook: 'https://www.facebook.com',
    twitter: 'http://www.twitter.com',
    translations: {
        fr: {
            test: 'Fr test',
            readMore: 'Lire plus',
            readLess: 'Lire moins',
            follow: 'Suivre',
            writeTestimonial: 'Vous aussi,<br> exprimez-vous !',
            pdfFile: 'Pour plus d’information,<br> téléchargez notre plaquette PDF',
            ourTeam: 'Notre équipe',
            form: {
                first_name: 'Prénom',
                last_name: 'Nom',
                phone: 'Téléphone'
            },
            terms: "J'accepte que mes informations personnelles soient publiées avec mon avis",
            required: "champs obligatoires",
            getInTouch: "Prenez contact <br> avec nous",
            oimsButton: "Une solution pour les professionnels de la gestion"
        },
        en: {
            test: 'En test',
            readMore: 'Read More',
            readLess: 'Read Less',
            follow: 'Follow',
            writeTestimonial: 'You too,<br> express yourself!',
            pdfFile: 'For more information, <br> download our PDF brochure',
            ourTeam: 'Our Team',
            form: {
                first_name: 'Name',
                last_name: 'Last Name',
                phone: 'Phone'
            },            
            terms: "I agree that my personal information will be published with my opinion",
            required: "required fields",
            getInTouch: "Get in touch <br> with us",
            oimsButton: "A solution for wealth management professionals"
        }
    }
  }
}

export default AppConstants